export default {
  name: 'misc.situation',
  key: 'situation',
  attributes: {
    distress: {
      key: 'distress',
      name: 'entity.refuelingStation.situation.distress',
    },
    pirates: {
      key: 'pirates',
      name: 'entity.refuelingStation.situation.pirates',
    },
    agents: {
      key: 'agents',
      name: 'entity.refuelingStation.situation.agents',
    },
    saboteurs: {
      key: 'saboteurs',
      name: 'entity.refuelingStation.situation.saboteurs',
    },
    alien: {
      key: 'alien',
      name: 'entity.refuelingStation.situation.alien',
    },
  },
};
